var _defs, _rect, _path, _path2, _polyline;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIncandescentLampLightbulb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1, .cls-2 {\n        fill: none;\n      }\n\n      .cls-2 {\n        stroke: #fff;\n        stroke-miterlimit: 10;\n        stroke-width: 0.25px;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 16,
    height: 16
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M11.6,4a4,4,0,1,1,0,8,4.28,4.28,0,0,1-3.4-1.9,7.91,7.91,0,0,1-.5-1A3.42,3.42,0,0,1,7.5,8a2.8,2.8,0,0,1,.2-1.1A2.52,2.52,0,0,1,8.1,6,4.87,4.87,0,0,1,11.6,4Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M.4,5.8a50.84,50.84,0,0,1,7.7.1c.2,0,2.4.2,2.9,1.2a2,2,0,0,1,.2.8,1.69,1.69,0,0,1-.3,1c-.5.9-2.3,1.1-2.7,1.2a66.06,66.06,0,0,1-7.8,0"
  })), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    className: "cls-2",
    points: "8.1 5.9 7.8 6.6 7.6 7.5 7.6 8.3 7.8 9.1 8.2 10.1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIncandescentLampLightbulb);
export default __webpack_public_path__ + "static/media/IncandescentLampLightbulb.c47aa27a2024b77081a10c841f8ccf5b.svg";
export { ForwardRef as ReactComponent };